const normalizedStage = process.env.STAGE || 'local'

export default {
  localStorageKey: `esb-${normalizedStage}`,
  apiVersion: '1'
}
